import { render, staticRenderFns } from "./ChangeReasonModal.vue?vue&type=template&id=9bf81062&scoped=true&"
import script from "./ChangeReasonModal.vue?vue&type=script&lang=js&"
export * from "./ChangeReasonModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bf81062",
  null
  
)

export default component.exports